export namespace Oss {
    export enum OssUseType {
        /** 表单 */
        FORM = 'form',
        /** 评论 */
        SNS = 'sns',
        /** 描述控件 */
        DESCRIBEIMAGE = 'describeimage',
        /** 自定义logo上传 */
        LOGO = 'logo',
        /** 导入 */
        Import = 'import',
        /** AI智能识别 */
        AIAGENT = 'aiagent',
        /** AI-OCR模板样本图片 */
        AIRecognition = 'airecognition',
    }

    /** oss文件上传凭证场景（设计上应该和上面用一个枚举，但这个枚举使用的地方只用到了这一个） */
    export enum OssAuthScene {
        /** 空场景，意思是没有场景 */
        Empty = 'empty',
        /** AI智能识别 */
        AIAGENT = 'aiagent',
        /** AI-OCR模板样本图片 */
        AIRecognition = 'airecognition',
    }

    export interface IOssInfo {
        /** 由服务器端指定的Policy过期时间 */
        expiration: number;
        /** 访问密钥 */
        credential: string;
        /** 对Policy签名后的字符串 */
        signature: string;
        /** 请求的时间 */
        requestTime: string;
        /** 指定签名的版本和算法 */
        signatureVersion: string;
        /** Bucket域名 */
        host: string;
        /** 限制上传的文件前缀 */
        dir: string;
        /** 安全策略 */
        policy: string;
    }

    export namespace FileHeaders {
        // 草稿文件头信息
        export type TFileHeadersParams = {
            fileId: string;
            sourceFileId?: string;
            storageKey?: string;
            fileName?: string;
            contentType?: string;
            contentLength?: string;
            desc?: string;
            sortKey?: number;
        };
    }
    export namespace Response {
        export type IOssTokenRes = IOssInfo;

        export interface IOssUrlRes {
            /** 原始文件地址 */
            originalUrl: string;
            /** 预览 质量压缩地址  */
            previewUrl: string;
            /** 文件大小 */
            fileSize: number;
            /** 文件ID */
            fileId: string;
        }

        export interface ISaveFileHeaderRes {
            fileId: string;
            thumbnailUrl?: string;
        }
    }
}
